// src/pages/Privacy.jsx
import React from 'react';

const styles = {
  page: {
    minHeight: '100vh',
    background: 'var(--ka-navy)',
    color: 'var(--ka-white)',
    padding: '60px 40px',
    position: 'relative',
    overflow: 'hidden',
  },
  bgPattern: {
    position: 'absolute',
    inset: 0,
    backgroundImage: `
      radial-gradient(ellipse at 20% 50%, rgba(200,151,58,0.08) 0%, transparent 60%),
      radial-gradient(ellipse at 80% 20%, rgba(200,151,58,0.05) 0%, transparent 50%)
    `,
    pointerEvents: 'none',
  },
  inner: {
    maxWidth: 720,
    margin: '0 auto',
    position: 'relative',
    zIndex: 2,
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 12,
    marginBottom: 48,
    textDecoration: 'none',
  },
  kaCircle: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    background: 'var(--ka-gold)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 18,
    fontWeight: 800,
    fontFamily: 'var(--font-display)',
    color: 'var(--ka-navy)',
  },
  kaName: {
    fontFamily: 'var(--font-display)',
    fontSize: 18,
    fontWeight: 700,
    color: 'var(--ka-white)',
    lineHeight: 1.2,
  },
  kaSub: {
    fontSize: 10,
    color: 'var(--ka-gold-light)',
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    marginTop: 2,
  },
  divider: {
    width: 48,
    height: 3,
    background: 'var(--ka-gold)',
    borderRadius: 2,
    margin: '20px 0 32px',
  },
  h1: {
    fontFamily: 'var(--font-display)',
    fontSize: 36,
    fontWeight: 700,
    color: 'var(--ka-white)',
    marginBottom: 4,
  },
  updated: {
    fontSize: 13,
    color: 'rgba(255,255,255,0.4)',
    marginBottom: 40,
  },
  h2: {
    fontFamily: 'var(--font-display)',
    fontSize: 18,
    fontWeight: 700,
    color: 'var(--ka-gold)',
    marginTop: 36,
    marginBottom: 10,
  },
  p: {
    fontSize: 15,
    color: 'rgba(255,255,255,0.75)',
    lineHeight: 1.8,
    marginBottom: 16,
  },
  link: {
    color: 'var(--ka-gold)',
    textDecoration: 'none',
  },
  footer: {
    marginTop: 64,
    paddingTop: 24,
    borderTop: '1px solid rgba(255,255,255,0.1)',
    fontSize: 12,
    color: 'rgba(255,255,255,0.3)',
    textAlign: 'center',
  },
};

export default function Privacy() {
  return (
    <div style={styles.page}>
      <div style={styles.bgPattern} />
      <div style={styles.inner}>

        <a href="/" style={styles.badge}>
          <div style={styles.kaCircle}>KA</div>
          <div>
            <div style={styles.kaName}>King's Academy</div>
            <div style={styles.kaSub}>Madaba, Jordan</div>
          </div>
        </a>

        <h1 style={styles.h1}>Privacy Policy</h1>
        <div style={styles.divider} />
        <p style={styles.updated}>Last updated: March 2026</p>

        <p style={styles.p}>
          This privacy policy explains how the King's Academy Faculty Tool Kit
          ("the portal") collects and uses information. The portal is an internal
          tool for King's Academy faculty and staff — it is not open to the
          general public.
        </p>

        <h2 style={styles.h2}>What we collect</h2>
        <p style={styles.p}>
          When you sign in with your King's Academy Google account, we receive
          your name, email address, and profile photo from Google. We store this
          information in our database to identify you within the portal and to
          control access to the tools available to you.
        </p>
        <p style={styles.p}>
          We do not collect any information beyond what is needed to run the
          portal and its tools.
        </p>

        <h2 style={styles.h2}>How we use it</h2>
        <p style={styles.p}>
          Your information is used solely to authenticate you, display your name
          in the interface, and manage your access permissions. We do not sell,
          share, or use your data for advertising or any purpose outside the
          operation of the portal.
        </p>

        <h2 style={styles.h2}>Who can see your data</h2>
        <p style={styles.p}>
          Your information is only accessible to portal administrators and the
          King's Academy technology team. It is stored securely in Google
          Firebase, which is bound by Google's own privacy and security
          standards.
        </p>

        <h2 style={styles.h2}>Cookies and tracking</h2>
        <p style={styles.p}>
          The portal uses a session cookie to keep you signed in. We do not use
          any third-party analytics or advertising trackers.
        </p>

        <h2 style={styles.h2}>Your rights</h2>
        <p style={styles.p}>
          You can request to view or delete your account data at any time by
          contacting us at the address below. Deleting your account will remove
          your stored profile from the portal, though your King's Academy Google
          account itself is managed separately by the school.
        </p>

        <h2 style={styles.h2}>Contact us</h2>
        <p style={styles.p}>
          If you have any questions about this policy or how your data is
          handled, please reach out to:{' '}
          <a href="mailto:techcommunications@kingsacademy.edu.jo" style={styles.link}>
            techcommunications@kingsacademy.edu.jo
          </a>
        </p>

        <div style={styles.footer}>
          King's Academy · Madaba, Jordan · Faculty Tool Kit
        </div>
      </div>
    </div>
  );
}